module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("India"), _c('br'), _vm._v("Defending the Jewel in the Crown"), _c('br'), _vm._v("First published in 1931. Speeches © Estate of Winston S. Churchill")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Cover art to the electronic edition copyright © 2013 by RosettaBooks, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Image of Winston Churchill with other electoral candidates reproduced by permission of Curtis Brown, London, on behalf of The Broadwater Collection, an archive of photographs owned by the Churchill family and held at the Churchill Archives Centre, Cambridge.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Electronic edition published 2013 by RosettaBooks, LLC, New York."), _c('br'), _vm._v("Cover jacket design by Alexia Garaventa"), _c('br'), _vm._v("ISBN e-Pub edition: 9780795329296")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/v-1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("CHURCHILL IN 1932"), _c('br'), _vm._v("PROVINCIAL ARCHIVES OF ALBERTA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d230dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 63
// module chunks = 0